import { useEffect, useRef, useState } from 'react';

export const useScrollable = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const SCROLL_SPEED = 2;

  const updateScrollState = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
    }
  };

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  const handleScroll = () => {
    updateScrollState();
  };

  const handleWheel = (event: WheelEvent) => {
    if (scrollRef.current) {
      if (event.deltaY !== 0) {
        event.preventDefault();
        scrollRef.current.scrollBy({
          left: event.deltaY * SCROLL_SPEED,
          behavior: 'smooth',
        });
      }
    }
  };

  useEffect(() => {
    const element = scrollRef.current;
    if (element) {
      element.addEventListener('scroll', handleScroll);
      element.addEventListener('wheel', handleWheel, { passive: false });
    }
    return () => {
      if (element) {
        element.removeEventListener('scroll', handleScroll);
        element.removeEventListener('wheel', handleWheel);
      }
    };
  }, []);

  return { scrollRef, scrollLeft, scrollRight, canScrollLeft, canScrollRight, updateScrollState };
};
